import * as actionTypes from "./actionTypes";
import axios from "axios";
import { auth, googleProvider, facebookProvider } from "../../Firebase/firebase";
import {requestFirebaseNotificationPermission, isSpported, database} from "../../Firebase/firebase";

export const initAuth = () => {
    return {
        type: actionTypes.INIT_AUTHENTICATING,
        loadingAuth: true
    }
};

export const successAuth = (user) => {
    return {
        type: actionTypes.SUCCESS_AUTHENTICATING,
        user: user,
        loadingAuth: false,
        userEmail: localStorage.getItem('user'),
        loggedOut: false

    }
}

export const failAuth = (error => {
    return {
        type: actionTypes.FAIL_AUTHENTICATING,
        error: error,
        loadingAuth: false
    }
})

export const clearError = () => {
    return {
        type: actionTypes.CLEAR_ERROR,
        error: false
    }
};

export const successLogouAuth = () => {
    return {
        type: actionTypes.SUCCESS_LOGOUT_AUTHENTICATION,
        user: null,
        loggedOut: true,
        userEmail: localStorage.getItem('user')
    }
};


export const logoutAuth = () => {
    return dispatch => {
        auth.signOut()
            .then(() => {
                localStorage.removeItem('idToken');
                localStorage.removeItem('user');
                localStorage.removeItem('myWish');
                localStorage.removeItem('uid');
                dispatch(successLogouAuth());
            })
            .catch(error => {
                console.log(error);
            })
    }

};

export const successGetLogedUserData = (data) => {
    return {
        type: actionTypes.SUCCESS_GET_CURRENT_LOGED_USER_DATA,
        currentUser: data.data
    }
};

export const failGetLogedUserData = (error) => {
    return {
        type: actionTypes.SUCCESS_GET_CURRENT_LOGED_USER_DATA,
        currentUserError: error
    }
};



export const getCurrentLogedUserData = (bearerToken) => {
    const config = {
        headers: {
            Authorization: "Bearer " + bearerToken
        }
    }
    return dispatch => {
        axios.get('users/me', config)
            .then(response => {
                const uid = response.data.data.id
                
                localStorage.setItem('uid', uid);
                dispatch(successGetLogedUserData(response.data))
                if (isSpported()){
                    requestFirebaseNotificationPermission()
                    .then((firebaseToken) => {
                        localStorage.setItem('fcmToken', firebaseToken)
                        database.ref(`recivers/${uid}`).set({ token: firebaseToken, id: uid, email: localStorage.getItem('user') })
                            .then(res => console.log('sentToFIreDataBase', res))
                    });
                }
            })
            .catch(error => {
                dispatch(failGetLogedUserData(error.message))
            })
    }
}


export const startAuth = (email, password, mode) => {
    if (mode === 'signIn') {
        return dispatch => {
            dispatch(initAuth());
            auth.signInWithEmailAndPassword(email, password)
                .then(response => {
                    const fireUser = response.user
                    if (fireUser) {
                        if (!fireUser.emailVerified) {
                            fireUser.sendEmailVerification().then(res=> {
                                // Email sent.
                                console.log('new mail', res)
                              }).catch(function(error) {
                                console.log(error)
                              });
                            
                            dispatch(failAuth('Your email address is not verified, please check your email'));
                            dispatch(logoutAuth())
                        }
                    }
                })
                .catch(error => {
                    const errorCode = error.code;
                    let errorMessage = 'Error';
                    switch (errorCode) {
                        case 'auth/wrong-password':
                            errorMessage = 'wrong password'
                            break;
                        case 'auth/invalid-email':
                            errorMessage = 'invalid email'
                            break;
                        case 'auth/user-not-found':
                            errorMessage = 'email not found'
                            break;
                        default:
                            errorMessage = 'Error'
                    }
                    dispatch(failAuth(errorMessage))
                })
        }
    }
    if (mode === 'signUp') {
        return dispatch => {
            dispatch(initAuth());
            auth.createUserWithEmailAndPassword(email, password)
                .then(response => {
                    const fireUser = response.user
                    if (fireUser) {
                        if (!fireUser.emailVerified) {
                            fireUser.sendEmailVerification().then(res=> {
                                // Email sent.
                                console.log('new mail', res)
                              }).catch(function(error) {
                                console.log(error)
                              });
                            
                            dispatch(failAuth('Your email address is not verified, please check your email'));
                            dispatch(logoutAuth())
                        }
                    }
                })
                .catch(error => {
                    const errorCode = error.code;
                    let errorMessage = 'Error';
                    switch (errorCode) {
                        case 'auth/email-already-in-use':
                            errorMessage = 'email already exist'
                            break;
                        case 'auth/invalid-email':
                            errorMessage = 'invalid email'
                            break;
                        case 'auth/weak-password':
                            errorMessage = 'weak password'
                            break;
                        default:
                            errorMessage = 'Error'
                    }
                    dispatch(failAuth(errorMessage))
                })
        }
    }
    if (mode === 'passwordReset') {
        return dispatch => {
            auth.sendPasswordResetEmail(email).then((response) => {
                console.log(response)
            }).catch((error) => {
                console.log(error)
            });
        }
    }
    if (mode === 'verifyEmail') {
        return dispatch => {
            console.log(mode)
        }
    }

};

export const googleAuth = () => {
    return dispatch => {
        auth.signInWithPopup(googleProvider)
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log('GOOGEL AUTH ERROR\n#######################',error + '\n',error.message, '\n#######################')
                dispatch(failAuth('Error'))
            })
    }
};

export const facebookAuth = () => {
    return dispatch => {
        auth.signInWithPopup(facebookProvider)
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error)
                dispatch(failAuth('Error'))
            })
    }
};